<template>
<div id="app">
    <notifications></notifications>
    <router-view />
</div>
</template>

<script>
import configPOPTheme from '@/config/POPTheme'

export default {
    name: 'POPSHIPPOP',
    data() {
        return {
            color: "vue", //vue|blue|orange|green|red|primary
            userLogin: "",
            createdBy: ""
        };
    },
    metaInfo: {
      title: configPOPTheme.webTitle || 'POP SHIPPOP',
      titleTemplate: '%s'
    },
}
</script>
